import React from 'react'
import PropTypes from 'prop-types'
import { CONTENT_TYPES } from '@helpers/constants'
import classNames from 'classnames'
import { getSubjectTextClass } from '@helpers/subject'
import Icon from '@components/Icon'

const SubjectHeader = (props) => {
  const {
    subject,
    type,
    dark = false,
    color,
    textSize = ''
  } = props

  const className = classNames(
    `flex items-center`,
    color ? color : getSubjectTextClass(subject.slug, dark ? 'dark' : 'light'),
    textSize ?? undefined
  )

  return (
    <div className={className}>
      <Icon icon={type === CONTENT_TYPES.BOOK ? 'Book' : 'Section'} />
      <span className='ml-2'>{subject.name}</span>
    </div>
  )
}

SubjectHeader.propTypes = {
  subject: PropTypes.object,
  type: PropTypes.string,
  dark: PropTypes.bool,
  color: PropTypes.string,
  textSize: PropTypes.string,
}

export default SubjectHeader
